import { UnderwriterSearchRequestQuery } from '@lio/api-types';

export const underwriterQueryKey = {
  search: ['underwriters'] as const,
  searchWithParams: (params: UnderwriterSearchRequestQuery) => [...underwriterQueryKey.search, params] as const,
};
